// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"b5517969","433":"1169a313","453":"8701dc61","455":"799278da","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};